var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizes-2021-section-place"},[_vm._v(_vm._s(_vm.place)+" место")])}
var staticRenderFns = []

export { render, staticRenderFns }